import { render } from "./thwHome.vue?vue&type=template&id=4b5b60b1&scoped=true"
import script from "./thwHome.vue?vue&type=script&lang=js"
export * from "./thwHome.vue?vue&type=script&lang=js"

import "./thwHome.vue?vue&type=style&index=0&id=4b5b60b1&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5b60b1"]])

export default __exports__